/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MatchOperationV2ShotType {
    OpenPlay = 'OPEN_PLAY',
    SevenMeter = 'SEVEN_METER'
}


export function instanceOfMatchOperationV2ShotType(value: any): boolean {
    for (const key in MatchOperationV2ShotType) {
        if (Object.prototype.hasOwnProperty.call(MatchOperationV2ShotType, key)) {
            if (MatchOperationV2ShotType[key as keyof typeof MatchOperationV2ShotType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchOperationV2ShotTypeFromJSON(json: any): MatchOperationV2ShotType {
    return MatchOperationV2ShotTypeFromJSONTyped(json, false);
}

export function MatchOperationV2ShotTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2ShotType {
    return json as MatchOperationV2ShotType;
}

export function MatchOperationV2ShotTypeToJSON(value?: MatchOperationV2ShotType | null): any {
    return value as any;
}

export function MatchOperationV2ShotTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchOperationV2ShotType {
    return value as MatchOperationV2ShotType;
}

